var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container content-comunicacao" },
    [
      _vm.conflitoSelecionado
        ? _c("modal-visualizar-conflito", {
            attrs: { conflito: _vm.conflitoSelecionado },
            on: {
              closeModal: function($event) {
                _vm.conflitoSelecionado = null
              }
            }
          })
        : _vm._e(),
      _c("div", { staticClass: "content-conversas full-width" }, [
        _c("div", { staticClass: "comunicacao-main" }, [
          _c(
            "div",
            { staticClass: "busca-comunicacao" },
            [
              _c("search-conflitos", {
                attrs: { botaoLimpar: true },
                on: { search: _vm.search, limpar: _vm.handleLimpar }
              })
            ],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "content-conversas full-width" }, [
        _c("div", { staticClass: "comunicacao-main" }, [
          _c(
            "div",
            { staticClass: "listagem-conversas" },
            [
              _c("app-listagem", {
                attrs: {
                  "has-refresh-button": true,
                  showButtonOrdemServico: false,
                  showButtonAssinatura: false,
                  "has-expansivel": false,
                  "json-headers": _vm.colunas,
                  "json-data": _vm.items,
                  totalElements: _vm.totalElements,
                  pagina: _vm.filtroPesquisa.pagina,
                  hasFiltroRapido: false,
                  hasActionButton: false,
                  filtro: _vm.filtroPesquisa,
                  infoPrazos: false,
                  headerLabel: "Listagem de processos com conflitos",
                  showCsvButton: false
                },
                on: {
                  atualizarFiltro: _vm.atualizarFiltro,
                  updateListagem: _vm.search,
                  changePage: _vm.changePage,
                  sort: _vm.sort,
                  executar: _vm.executar
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15e7cd41", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e7cd41","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/comunicacao/Conflitos.vue
// module id = null
// module chunks = 